import { PROMO_PHASES, type PromoPhase } from './phases';

export const getDynamicDiscount = (): number => {
	const now = new Date();
	const activePhase = PROMO_PHASES.find(
		(phase) => now >= phase.startDate && now <= phase.endDate,
	);
	return activePhase ? activePhase.discountPercentage : 0;
};

export const getCurrentPromoPhase = (): PromoPhase | null => {
	const now = new Date();
	const activePhase = PROMO_PHASES.find(
		(phase) => now >= phase.startDate && now <= phase.endDate,
	);
	return activePhase || null;
};
